/*
 * How a gateway type is named and coloured on the dashboard. The known
 * types keep a fixed hue (identity never changes with the data); an
 * unknown code gets a stable hue derived from its name.
 */

const LABELS: Record<string, string> = {
  PGA: 'PGA',
  P4GU: 'P4GU',
  IOTL: 'IoT-Lift',
  IOT: 'IoT-Lift',
  TMS2: 'TMS2',
  IPBOX: 'IP-BOX',
  UNKN: 'Unknown',
};

const COLORS: Record<string, string> = {
  PGA: '#2a78d6',
  TMS2: '#eb6834',
  P4GU: '#7c5cd6',
  IOTL: '#1f9d6a',
  IOT: '#1f9d6a',
  IPBOX: '#0e9aa7',
  UNKN: '#8b949e',
};

export const deviceTypeLabel = (type: string, unknownLabel?: string): string =>
  type === 'UNKN' && unknownLabel ? unknownLabel : LABELS[type] ?? type;

export const deviceTypeColor = (type: string): string => {
  if (COLORS[type]) return COLORS[type];
  let h = 0;
  for (let i = 0; i < type.length; i += 1) h = (h * 31 + type.charCodeAt(i)) | 0;
  return `hsl(${Math.abs(h) % 360} 55% 48%)`;
};

/** A share as a whole percentage, with "<1" for the tiny ones instead of a misleading 0. */
export const percentOf = (part: number, total: number): string => {
  if (total <= 0 || part <= 0) return '0';
  const pct = (part / total) * 100;
  return pct < 1 ? '<1' : String(Math.round(pct));
};
